import { Component, Input, OnChanges, OnInit, Output, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { Menu } from "./menu-item.model";
import { CdkOverlayOrigin, ConnectionPositionPair } from "@angular/cdk/overlay";
import { EventEmitter } from '@angular/core';
import { AppContext } from "../../../contexts/app-context";
import { RoutePath } from "../../../models/domains/route-paths.model";

@Component({
  selector: "menu-item",
  templateUrl: "./menu-item.component.html",
  styleUrls: ["./menu-item.component.scss"],
})
export class MenuItemComponent implements OnChanges, OnInit {
  @Input() items: Menu[];
  @Input() isOpened: boolean;
  @Input() openMenu: boolean = false;
  @Input() trigger!: CdkOverlayOrigin;
  @Output() closeMenu = new EventEmitter();
  @ViewChild("childMenu") public childMenu;
  isProduto = false;
  positionPairs: ConnectionPositionPair[] = [
    {
      offsetX: 185,
      originX: "end",
      originY: "center",
      overlayX: "end",
      overlayY: "top"
    },
  ];

  constructor(private router: Router, private context: AppContext) { }

ngOnInit(){
  this.fontColorValidation();
  this.btnColorValidation();
}

  ngOnChanges() {
    this.positionPairs = [
      {
        offsetX: this.isOpened ? 185 : 60,
        originX: "end",
        originY: "center",
        overlayX: "end",
        overlayY: "top"
      },
    ];
  }

  goTo(route: RoutePath): void {
    this.closeMenu.emit();
    this.router.navigate([route]);
  }

  goExternal(route: string): void {
    this.closeMenu.emit();
    window.open(route);
  }

  
  btnColorValidation() {
    const btnColor = this.context.getCurrentTenant().tenantStyle.buttonBackgroundColor.toString();
    if (btnColor == '') {
      return "#9389fb;";
    } else {
      return btnColor;
    }
  }

  fontColorValidation() {
    const fontColor = this.context.getCurrentTenant().tenantStyle.fontColor.toString();
    if (fontColor == '') {
      return "#fefefe;";
    } else {
      return fontColor;
    }
  }
}
